module.exports = __webpack_public_path__ + "img/hunt_shipping.8c447d0e.png";